import { AppCardMedia, AppCardMediaOverlay } from '@app/components/base/app-card';
import { CardMediaPill } from '@app/components/base/CardMediaPill';
import { LDate } from '@app/components/date/LDate';
import { LTime } from '@app/components/date/LTime';
import { FRAGMENT_CARD_PADDING_X } from '@app/modules/fragments/screens/list/fragment-card/constants';
import { YoutubeBroadcast, YoutubeBroadcastVideo } from '../../youtube-broadcast-types';
import { DurationForRange } from '@mi-front/ui';
import { Box } from '@mui/material';
import { YoutubeBroadcastThumbnail } from '../shared/YoutubeBroadcastThumbnail';

interface YoutubeBroadcastCardMediaProps {
  broadcast: YoutubeBroadcast;
}

/**
 * Broadcast card media: 16:9 thumbnail with overlay pills for date/time and duration.
 */
export function YoutubeBroadcastCardMedia({ broadcast }: YoutubeBroadcastCardMediaProps) {
  return (
    <AppCardMedia sx={{ aspectRatio: '16/9', overflow: 'hidden' }}>
      <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
        <YoutubeBroadcastThumbnail video={broadcast.video} />
        <AppCardMediaOverlay
          overlayPosition="top-left"
          inset={1}
          sx={{ left: FRAGMENT_CARD_PADDING_X }}
        >
          <CardMediaPill>
            <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
              <LDate
                value={broadcast.streamStartedAt}
                weekday="short"
                day="numeric"
                capitalize
                showTodayYesterday
              />
              <LTime value={broadcast.streamStartedAt} />
            </Box>
          </CardMediaPill>
        </AppCardMediaOverlay>
        <AppCardMediaOverlay
          overlayPosition="bottom-right"
          inset={1}
          sx={{ right: FRAGMENT_CARD_PADDING_X }}
        >
          <CardMediaPill>
            <DurationForRange
              from={broadcast.streamStartedAt}
              to={broadcast.streamEndedAt}
              hideSeconds
              unitDisplay="narrow"
            />
          </CardMediaPill>
        </AppCardMediaOverlay>
      </Box>
    </AppCardMedia>
  );
}
